// Core
import React, { useMemo } from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Plugins
import { formatValueWithUnit } from '../../../../../../../../plugins/general';

// Components
import { Col } from '../../../../../../../../layout/elements/Col';
import { EquipmentSensorListItem } from '../../../../../../../../components/EquipmentSensorList';
import { Row } from '../../../../../../../../layout/elements/Row';
import { EmptyBox } from '../../../../../../../../components/EmptyBox';
import { Thermometer } from '../../../../../../../../layout/icons';

// Modules
import { ListModule } from '../../../ListModule';

// View
import { VibrationProps } from './Vibration.types';
import { Container } from './Vibration.style';

function Vibration({
  className,
  unitData,
  testId,
}: VibrationProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  const sensors: EquipmentSensorListItem[] = useMemo(() => [
    ...(unitData?.vibrationSensor1Enable ? [{
      sensor: `${t('view.crusher.maintenance.setPoint.vibration.vibration1Description')}`,
      setpoint: formatValueWithUnit(unitData?.spVibration1Warning, '%'),
    }] : []),
    ...(unitData?.vibrationSensor2Enable ? [{
      sensor: `${t('view.crusher.maintenance.setPoint.vibration.vibration2Description')}`,
      setpoint: formatValueWithUnit(unitData?.spVibration2Warning, '%'),
    }] : []),
    ...(unitData?.vibrationSensor3Enable ? [{
      sensor: `${t('view.crusher.maintenance.setPoint.vibration.vibration3Description')}`,
      setpoint: formatValueWithUnit(unitData?.spVibration3Warning, '%'),
    }] : []),
    ...(unitData?.vibrationSensor4Enable ? [{
      sensor: `${t('view.crusher.maintenance.setPoint.vibration.vibration4Description')}`,
      setpoint: formatValueWithUnit(unitData?.spVibration4Warning, '%'),
    }] : []),
  ], [unitData, t]);

  // Check if any vibration sensor is enabled
  const hasAnyVibrationSensor: boolean = useMemo(() => !!(
    unitData?.vibrationSensor1Enable
    || unitData?.vibrationSensor2Enable
    || unitData?.vibrationSensor3Enable
    || unitData?.vibrationSensor4Enable
  ), [unitData]);

  return (
    <Container className={className} data-testid={testId}>
      <Row>
        {hasAnyVibrationSensor ? (
          <Col cols={24} lg={12}>
            <ListModule
              title={t('view.crusher.maintenance.setPoint.vibration.title')}
              items={sensors}
            />
          </Col>
        ) : (
          <Col cols={24}>
            <EmptyBox
              icon={<Thermometer />}
              title={t('view.crusher.maintenance.setPoint.vibration.title')}
              description={t('common.noSensorsEnabled')}
              testId="vibration-empty-state"
            />
          </Col>
        )}
      </Row>
    </Container>
  );
}

export { Vibration };
